import React from 'react';
import { useState, useEffect } from 'react';
import "./UserMenu.css";
import { AccessTime, AnnouncementOutlined, NotificationsActive, ExpandMore } from '@mui/icons-material';
import { getNotifications } from "shared/services/railDocumentsApi";
import { useNavigate } from "react-router-dom"
import { Notifications } from 'shared/models/api/models';
import { notificationsState, NotificationsState } from "./NotificationsState";
import { getTimeDiffText, getCardBodyText, INotificationCardProps } from 'shared/notifications/helpers';
import { fatigueAssessmentFormUrl } from 'components/ui/FatigueAssessmentRules';


import {

    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem

} from 'reactstrap';
import { MyDocumentsDocumentViewTraditional, MyDocumentsDocumentViewCBTC } from '../ui/DocumentRules';
import { RulebookModeEnum, RulebookNameToEnum } from '../../shared/enums/rulebook-mode-enum';
import { getUserExistingRulebookMode } from '../../shared/store/applicationState';

export default () => {
    const [stateNotifications, setStateNotifications] = useState({} as Notifications);
    const [loading, setLoading] = useState(false);
    const [requireRefresh, setRequireRefresh] = useState(true);
    const [lastCheckedTime, setLastCheckedTime] = useState(new Date());
    const [rulebookMode, setRulebookMode] = useState('')

    const maxNotificationsInView: number = 8;

    const navigate = useNavigate();
    const mode = getUserExistingRulebookMode();

    const getNotificationsForMenu = async () => {
        notificationsState.setLoading(true);
        notificationsState.setRequireRefresh(false);

        getNotifications(mode!)
            .then(notifications => {
                notificationsState.setNotifications(notifications);
            });

        notificationsState.setLoading(false);
    };

    const notificationCount = () => {
        const faCount = stateNotifications?.fatigueAssessments?.length || 0;
        const docCount = stateNotifications?.documentNotifications?.length || 0;
        return faCount + docCount;
    };

    useEffect(() => {
        const notificationsStateSubscribe = notificationsState.subscribe((s: NotificationsState) => {
            setStateNotifications(s.stateNotifications);
            setLastCheckedTime(new Date());
            setLoading(s.loading);
            setRequireRefresh(s.requireRefresh);
        });

        if (requireRefresh && !loading) {
            getNotificationsForMenu();
        }

        return () => {
            notificationsStateSubscribe.unsubscribe();
        };
    }, [stateNotifications, loading, requireRefresh]);

    const EmptyNotifications = () => (
        <DropdownItem header className="center-horizontally-vertically notifications-no-updates">
            <div><AccessTime fontSize="large"></AccessTime></div>
            <div className="p-4">There are currently no updates published.</div>
            <div>Check back in later.</div>
        </DropdownItem>
    );

    const navigateToFatigueAssessment = (id: number) => {
        navigate(fatigueAssessmentFormUrl(id));
    }

    const navigateToDocument = (id: number) => {
        navigate(`/pdf/view/${mode}/` + id);
    }

    const NotificationsList = () => {
        const faCount: number = stateNotifications?.fatigueAssessments?.length || 0;
        return (
            <>
                {stateNotifications?.fatigueAssessments?.map((faNotification, index) =>
                    <NotificationCard
                        key={index}
                        index={index}
                        id={faNotification.id}
                        time={faNotification.dateOfIssue}
                        clickAction={() => navigateToFatigueAssessment(faNotification.id)}
                        faId={faNotification.id}
                    ></NotificationCard>
                )}

                {stateNotifications?.documentNotifications?.map((docNotification, index) =>
                    <NotificationCard
                        key={index + faCount}
                        index={index + faCount}
                        id={docNotification.id}
                        time={docNotification.notifyDate}
                        clickAction={() => navigateToDocument(docNotification.documentId)}
                        documentId={docNotification.documentId}
                        documentTitle={docNotification.documentTitle}
                        documentNotifyType={docNotification.notifyType}
                    ></NotificationCard>
                )}

                <DropdownItem className="notification-card" >

                    <div className="notification-rect pt-2 pb-2" onClick={AllNotificationsRedirect}>
                        <span className="See-all-Notifications">See all notifications</span>
                    </div>
                </DropdownItem>

            </>
        )
    };

    const NotificationCard = (props: INotificationCardProps) => {
        if (props.index >= maxNotificationsInView) {
            return <></>;
        }
        return (
            <DropdownItem className="notification-card" onClick={props.clickAction}>
                <div className="container p-0">
                    <div className="row p-1 pt-3">
                        <div className="col col-sm-2">
                            <div className="notification-left-icon">
                                <AnnouncementOutlined fontSize="large"></AnnouncementOutlined>
                            </div>
                        </div>
                        <div className="col-9 col-sm-8 message">
                            {getCardBodyText(props)}
                        </div>
                        <div className="col col-sm-2">
                            {getTimeDiffText(props)}
                        </div>
                    </div>
                </div>
            </DropdownItem>
        )
    };

    const checkNotificationUpdateTimer = () => {
        //If notifications haven't been checked in this past time period, then check now
        const checkNotificationsMins = 1;

        //1000ms * 60s * checkNotificationsMins
        if (new Date().getTime() - lastCheckedTime.getTime() > 1000 * 60 * checkNotificationsMins) {
            setLastCheckedTime(new Date());
            setRequireRefresh(true);
        }
    }

    const AllNotificationsRedirect = () => {
        if (RulebookNameToEnum(mode) === RulebookModeEnum.Traditional) {
            navigate(MyDocumentsDocumentViewTraditional.url);
        } else if (RulebookNameToEnum(mode) === RulebookModeEnum.CBTC) {
            navigate(MyDocumentsDocumentViewCBTC.url);
        } else {
            console.log('Redirection to Notifications failed - document mode is not set');
        }
        
    }

    return (
        <UncontrolledDropdown setActiveFromChild className='notifications-uncontrolled'>
            <DropdownToggle tag='a' className='nav-link' caret onClick={checkNotificationUpdateTimer}>
                <NotificationsActive className="notification-icon" /><span className="nav-bar-text notifications">Notifications</span><ExpandMore />
            </DropdownToggle>
            <DropdownMenu right className="notification-dropdown p-0">
                {notificationCount() > 0
                    ?
                    <NotificationsList></NotificationsList>
                    :
                    <EmptyNotifications></EmptyNotifications>
                }
            </DropdownMenu>
        </UncontrolledDropdown>);
}
